import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormField } from "@/components/Interface/FormFields/FormField/FormField";
import { DeviceDetailsForm } from "@/components/Portal/DeviceManagement/Details/Details";
import { FieldRow } from "@/components/Portal/UserAccount/PersonalDetails/FieldRow/FieldRow";
import {
  DEFAULT_TEXT_FIELD_REGEX,
  SIM_ALIAS_MAX_LENGTH,
} from "@/utils/constants";

/** The device name row inside the "Gerätedetails" card - a display value, or the input while `Details` has it in edit mode. */
export const DeviceNameRow = ({ isEditing }: { isEditing: boolean }) => {
  const { t } = useTranslation();

  const {
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext<DeviceDetailsForm>();
  const alias = watch("alias");
  const deviceNameLabel = t("portal:common.device.attributes.deviceName");

  if (!isEditing) {
    return (
      <FieldRow
        dataTestid="device-name-display"
        label={deviceNameLabel}
        value={alias}
        disabled
      />
    );
  }

  return (
    <FormField<DeviceDetailsForm>
      id="device-name-input"
      name="alias"
      label={deviceNameLabel}
      layout="stacked"
      errors={errors}
      register={register}
      options={{
        onChange: (e: KeyboardEvent) => {
          const input = e.target as HTMLInputElement;
          let value = input.value;
          if (value.length > SIM_ALIAS_MAX_LENGTH) {
            value = value.substring(0, SIM_ALIAS_MAX_LENGTH);
          }
          setValue("alias", value, { shouldValidate: true, shouldDirty: true });
        },
        required: t("translation:label.validation.required"),
        pattern: {
          message: t("translation:Common.generalForm.error.genericRegexError"),
          value: DEFAULT_TEXT_FIELD_REGEX,
        },
        setValueAs: (value: string) => value?.trim(),
      }}
    />
  );
};
